
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PermissionService } from '../../modules/wino-shared/services/permission.service';
import { AuthService } from 'src/app/modules/wino-membership/services/auth.service';
import { HttpErrorHandler } from 'src/app/modules/wino-shared/utilities/http-error-handler';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    
    membershipModuleName: string = environment.membershipModuleName;

    permissionService: PermissionService;
    actualDate: Date;

    constructor(permissionService: PermissionService, private authService: AuthService,
    private router: Router, private errorHandler: HttpErrorHandler) { 
        this.permissionService = permissionService;
    }

  ngOnInit(): void {
    this.actualDate = new Date();
  }

    getClientCitizenFullName() : string {
        return (this.permissionService.getClientCitizenInfoFullName() ? this.permissionService.getClientCitizenInfoFullName() : "");
    }

    getClientLegalEntityInfoReference(): string {
        return (this.permissionService.getClientActiveLegalEntityInfoReference() ? this.permissionService.getClientActiveLegalEntityInfoReference() : "");
    }

    getUserInfoTitle(): string {
        return ( (this.permissionService.getClientCitizenInfoFullName() ? this.permissionService.getClientCitizenInfoFullName() : "") +
            (this.permissionService.getClientActiveLegalEntityInfoReference() ? ("\n" + this.permissionService.getClientActiveLegalEntityInfoReference()) : "") );
    }

  login() {
    this.router.navigateByUrl('/winoMembership/login');
  }

  register() {
    this.router.navigateByUrl('/winoMembership/registerUser');
  }

  logout() {
    this.authService.logoutUser().subscribe((success: boolean) => {
        if (success) {
            this.router.navigateByUrl('/home');
        } else {
            alert("ATTENZIONE: qualcosa non ha funzionato durante il logout");
        }
    }, error=> {
        this.errorHandler.handleError(error, "HeaderComponent");
        alert("ATTENZIONE: qualcosa non ha funzionato durante il logout");
        this.router.navigateByUrl('/home');
    });
  }

  admin() {
    this.router.navigateByUrl('/winoMembership/admin');
  }

  profile() {
    this.router.navigateByUrl('/winoMembership/profile');
  }
}
